<pa-select ngDefaultControl [formControl]="control"
    [placeholder]="schema.placeholder"
    [help]="schema.description"
    [label]="schema.title">
    <option *ngFor="let option of options" [value]="option.id">{{ option.name }}</option>
</pa-select>
